import { DriveType } from "../types/drive";

// Base drive specifications
export const DRIVE_SPECS = {
  [DriveType.JUMP]: {
    1: {
      type: DriveType.JUMP,
      name: "Jump-1 Drive",
      baseTons: 1,
      basePower: 10,
      baseMaintenance: 0.1,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-1 Drive",
    },
    2: {
      type: DriveType.JUMP,
      name: "Jump-2 Drive",
      baseTons: 2,
      basePower: 20,
      baseMaintenance: 0.2,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-2 Drive",
    },
    3: {
      type: DriveType.JUMP,
      name: "Jump-3 Drive",
      baseTons: 3,
      basePower: 30,
      baseMaintenance: 0.3,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-3 Drive",
    },
    4: {
      type: DriveType.JUMP,
      name: "Jump-4 Drive",
      baseTons: 4,
      basePower: 40,
      baseMaintenance: 0.4,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-4 Drive",
    },
    5: {
      type: DriveType.JUMP,
      name: "Jump-5 Drive",
      baseTons: 5,
      basePower: 50,
      baseMaintenance: 0.5,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-5 Drive",
    },
    6: {
      type: DriveType.JUMP,
      name: "Jump-6 Drive",
      baseTons: 6,
      basePower: 60,
      baseMaintenance: 0.6,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Jump-6 Drive",
    },
  },
  [DriveType.MANEUVER]: {
    1: {
      type: DriveType.MANEUVER,
      name: "Maneuver-1 Drive",
      baseTons: 1,
      basePower: 5,
      baseMaintenance: 0.05,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-1 Drive",
    },
    2: {
      type: DriveType.MANEUVER,
      name: "Maneuver-2 Drive",
      baseTons: 2,
      basePower: 10,
      baseMaintenance: 0.1,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-2 Drive",
    },
    3: {
      type: DriveType.MANEUVER,
      name: "Maneuver-3 Drive",
      baseTons: 3,
      basePower: 15,
      baseMaintenance: 0.15,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-3 Drive",
    },
    4: {
      type: DriveType.MANEUVER,
      name: "Maneuver-4 Drive",
      baseTons: 4,
      basePower: 20,
      baseMaintenance: 0.2,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-4 Drive",
    },
    5: {
      type: DriveType.MANEUVER,
      name: "Maneuver-5 Drive",
      baseTons: 5,
      basePower: 25,
      baseMaintenance: 0.25,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-5 Drive",
    },
    6: {
      type: DriveType.MANEUVER,
      name: "Maneuver-6 Drive",
      baseTons: 6,
      basePower: 30,
      baseMaintenance: 0.3,
      techLevel: 9,
      minRating: 1,
      maxRating: 6,
      description: "Standard Maneuver-6 Drive",
    },
  },
  [DriveType.REACTION]: {
    0: {
      type: DriveType.REACTION,
      name: "Reaction-0 Drive",
      baseTons: 1,
      basePower: 0,
      baseMaintenance: 0.02,
      techLevel: 7,
      minRating: 0,
      maxRating: 16,
      description: "Reaction drive, thrust 0 (station-keeping)",
    },
    1: {
      type: DriveType.REACTION,
      name: "Reaction-1 Drive",
      baseTons: 2,
      basePower: 0,
      baseMaintenance: 0.04,
      techLevel: 7,
      minRating: 1,
      maxRating: 16,
      description: "Reaction drive, thrust 1",
    },
    2: {
      type: DriveType.REACTION,
      name: "Reaction-2 Drive",
      baseTons: 4,
      basePower: 0,
      baseMaintenance: 0.08,
      techLevel: 7,
      minRating: 2,
      maxRating: 16,
      description: "Reaction drive, thrust 2",
    },
    3: {
      type: DriveType.REACTION,
      name: "Reaction-3 Drive",
      baseTons: 6,
      basePower: 0,
      baseMaintenance: 0.12,
      techLevel: 7,
      minRating: 3,
      maxRating: 16,
      description: "Reaction drive, thrust 3",
    },
    4: {
      type: DriveType.REACTION,
      name: "Reaction-4 Drive",
      baseTons: 8,
      basePower: 0,
      baseMaintenance: 0.16,
      techLevel: 8,
      minRating: 4,
      maxRating: 16,
      description: "Reaction drive, thrust 4",
    },
    5: {
      type: DriveType.REACTION,
      name: "Reaction-5 Drive",
      baseTons: 10,
      basePower: 0,
      baseMaintenance: 0.2,
      techLevel: 8,
      minRating: 5,
      maxRating: 16,
      description: "Reaction drive, thrust 5",
    },
    6: {
      type: DriveType.REACTION,
      name: "Reaction-6 Drive",
      baseTons: 12,
      basePower: 0,
      baseMaintenance: 0.24,
      techLevel: 8,
      minRating: 6,
      maxRating: 16,
      description: "Reaction drive, thrust 6",
    },
    7: {
      type: DriveType.REACTION,
      name: "Reaction-7 Drive",
      baseTons: 14,
      basePower: 0,
      baseMaintenance: 0.28,
      techLevel: 9,
      minRating: 7,
      maxRating: 16,
      description: "Reaction drive, thrust 7",
    },
    8: {
      type: DriveType.REACTION,
      name: "Reaction-8 Drive",
      baseTons: 16,
      basePower: 0,
      baseMaintenance: 0.32,
      techLevel: 9,
      minRating: 8,
      maxRating: 16,
      description: "Reaction drive, thrust 8",
    },
    9: {
      type: DriveType.REACTION,
      name: "Reaction-9 Drive",
      baseTons: 18,
      basePower: 0,
      baseMaintenance: 0.36,
      techLevel: 9,
      minRating: 9,
      maxRating: 16,
      description: "Reaction drive, thrust 9",
    },
    10: {
      type: DriveType.REACTION,
      name: "Reaction-10 Drive",
      baseTons: 20,
      basePower: 0,
      baseMaintenance: 0.4,
      techLevel: 10,
      minRating: 10,
      maxRating: 16,
      description: "Reaction drive, thrust 10",
    },
    11: {
      type: DriveType.REACTION,
      name: "Reaction-11 Drive",
      baseTons: 22,
      basePower: 0,
      baseMaintenance: 0.44,
      techLevel: 10,
      minRating: 11,
      maxRating: 16,
      description: "Reaction drive, thrust 11",
    },
    12: {
      type: DriveType.REACTION,
      name: "Reaction-12 Drive",
      baseTons: 24,
      basePower: 0,
      baseMaintenance: 0.48,
      techLevel: 10,
      minRating: 12,
      maxRating: 16,
      description: "Reaction drive, thrust 12",
    },
    13: {
      type: DriveType.REACTION,
      name: "Reaction-13 Drive",
      baseTons: 26,
      basePower: 0,
      baseMaintenance: 0.52,
      techLevel: 11,
      minRating: 13,
      maxRating: 16,
      description: "Reaction drive, thrust 13",
    },
    14: {
      type: DriveType.REACTION,
      name: "Reaction-14 Drive",
      baseTons: 28,
      basePower: 0,
      baseMaintenance: 0.56,
      techLevel: 11,
      minRating: 14,
      maxRating: 16,
      description: "Reaction drive, thrust 14",
    },
    15: {
      type: DriveType.REACTION,
      name: "Reaction-15 Drive",
      baseTons: 30,
      basePower: 0,
      baseMaintenance: 0.6,
      techLevel: 11,
      minRating: 15,
      maxRating: 16,
      description: "Reaction drive, thrust 15",
    },
    16: {
      type: DriveType.REACTION,
      name: "Reaction-16 Drive",
      baseTons: 32,
      basePower: 0,
      baseMaintenance: 0.64,
      techLevel: 12,
      minRating: 16,
      maxRating: 16,
      description: "Reaction drive, thrust 16",
    },
  },
} as const;

// Drive constants
export const DRIVE_CONSTANTS = {
  COSTS: {
    MANEUVER: 2, // MCr per ton
    REACTION: 0.2, // MCr per ton
    JUMP: 1.5, // MCr per ton
  },
  JUMP_DRIVE: {
    MIN_TONS: 10,
    ADDITIONAL_TONS: 5,
    MIN_RATING: 1,
    MAX_RATING: 6,
  },
} as const;

// Drive potential specifications
export const DRIVE_POTENTIAL = {
  MANEUVER: [
    { rating: 0, percentOfHull: 0.5, techLevel: 9 },
    { rating: 1, percentOfHull: 1, techLevel: 9 },
    { rating: 2, percentOfHull: 2, techLevel: 10 },
    { rating: 3, percentOfHull: 3, techLevel: 10 },
    { rating: 4, percentOfHull: 4, techLevel: 11 },
    { rating: 5, percentOfHull: 5, techLevel: 11 },
    { rating: 6, percentOfHull: 6, techLevel: 12 },
    { rating: 7, percentOfHull: 7, techLevel: 13 },
    { rating: 8, percentOfHull: 8, techLevel: 14 },
    { rating: 9, percentOfHull: 9, techLevel: 15 },
    { rating: 10, percentOfHull: 10, techLevel: 16 },
    { rating: 11, percentOfHull: 11, techLevel: 17 },
  ],
  REACTION: [
    { rating: 0, percentOfHull: 1, techLevel: 7 },
    { rating: 1, percentOfHull: 2, techLevel: 7 },
    { rating: 2, percentOfHull: 4, techLevel: 7 },
    { rating: 3, percentOfHull: 6, techLevel: 7 },
    { rating: 4, percentOfHull: 8, techLevel: 8 },
    { rating: 5, percentOfHull: 10, techLevel: 8 },
    { rating: 6, percentOfHull: 12, techLevel: 8 },
    { rating: 7, percentOfHull: 14, techLevel: 9 },
    { rating: 8, percentOfHull: 16, techLevel: 9 },
    { rating: 9, percentOfHull: 18, techLevel: 9 },
    { rating: 10, percentOfHull: 20, techLevel: 10 },
    { rating: 11, percentOfHull: 22, techLevel: 10 },
    { rating: 12, percentOfHull: 24, techLevel: 10 },
    { rating: 13, percentOfHull: 26, techLevel: 11 },
    { rating: 14, percentOfHull: 28, techLevel: 11 },
    { rating: 15, percentOfHull: 30, techLevel: 11 },
    { rating: 16, percentOfHull: 32, techLevel: 12 },
  ],
  JUMP: [
    { rating: 1, percentOfHull: 2.5, techLevel: 9 },
    { rating: 2, percentOfHull: 5, techLevel: 11 },
    { rating: 3, percentOfHull: 7.5, techLevel: 12 },
    { rating: 4, percentOfHull: 10, techLevel: 13 },
    { rating: 5, percentOfHull: 12.5, techLevel: 14 },
    { rating: 6, percentOfHull: 15, techLevel: 15 },
    { rating: 7, percentOfHull: 17.5, techLevel: 16 },
    { rating: 8, percentOfHull: 20, techLevel: 17 },
    { rating: 9, percentOfHull: 22.5, techLevel: 18 },
  ],
};

// Export constants
export const REACTION_DRIVE_THRUST_POTENTIAL = DRIVE_POTENTIAL.REACTION;
export const JUMP_DRIVE_POTENTIAL = DRIVE_POTENTIAL.JUMP;
export const DRIVE_COSTS = DRIVE_CONSTANTS.COSTS;
export const MIN_JUMP_DRIVE_TONS = DRIVE_CONSTANTS.JUMP_DRIVE.MIN_TONS;
export const JUMP_DRIVE_ADDITIONAL_TONS =
  DRIVE_CONSTANTS.JUMP_DRIVE.ADDITIONAL_TONS;

// Add DRIVE_TYPES constant before the helper functions
export const DRIVE_TYPES = ["jump", "maneuver", "reaction"] as const;

// Helper functions
export const getDriveSpec = (type: DriveType, rating: number) => {
  let key: keyof typeof DRIVE_POTENTIAL;
  switch (type) {
    case DriveType.MANEUVER:
      key = "MANEUVER";
      break;
    case DriveType.JUMP:
      key = "JUMP";
      break;
    case DriveType.REACTION:
      key = "REACTION";
      break;
    default:
      return undefined;
  }

  const potentialDrives = DRIVE_POTENTIAL[key];
  if (!potentialDrives) return undefined;
  return potentialDrives.find((drive) => drive.rating === rating);
};

export const getDriveCost = (
  type: DriveType,
  rating: number,
  shipSize: number,
): number => {
  const tons = getDriveTons(type, rating, shipSize);
  const spec = getDriveSpec(type, rating);
  if (!spec) return 0;

  // The cost is MCr2 per ton for maneuver drives.
  if (type === DriveType.MANEUVER) {
    return tons * 2000000;
  }

  // The cost is MCr1.5 per ton for jump drives.
  if (type === DriveType.JUMP) {
    return tons * 1500000;
  }

  // The cost is MCr0.2 per ton for reaction drives.
  if (type === DriveType.REACTION) {
    return tons * 200000;
  }

  return 0;
};

export const getDriveTons = (
  type: DriveType,
  rating: number,
  shipSize: number,
): number => {
  const spec = getDriveSpec(type, rating);
  if (!spec) return 0;

  const percentOfHull = spec.percentOfHull / 100;
  const baseTons = percentOfHull * shipSize;

  if (type === DriveType.JUMP) {
    const jumpTons = baseTons + JUMP_DRIVE_ADDITIONAL_TONS;
    return Math.max(jumpTons, MIN_JUMP_DRIVE_TONS);
  }

  return baseTons;
};

export const getDrivePower = (type: DriveType, rating: number): number => {
  const spec = getDriveSpec(type, rating);
  if (!spec) return 0;
  // Power requirements are based on the rating and type
  switch (type) {
    case DriveType.JUMP:
      return rating * 10; // 10 Power per rating
    case DriveType.MANEUVER:
      return rating * 5; // 5 Power per rating
    case DriveType.REACTION:
      return 0; // Reaction drives don't require power
    default:
      return 0;
  }
};

export const getDriveMaintenance = (
  type: DriveType,
  rating: number,
  shipSize: number,
): number => {
  const cost = getDriveCost(type, rating, shipSize);
  return cost * 0.001; // Maintenance is 0.1% of cost per year
};

export const validateDriveSpec = (type: DriveType, rating: number): boolean => {
  let key: keyof typeof DRIVE_POTENTIAL;
  switch (type) {
    case DriveType.MANEUVER:
      key = "MANEUVER";
      break;
    case DriveType.JUMP:
      key = "JUMP";
      break;
    case DriveType.REACTION:
      key = "REACTION";
      break;
    default:
      return false;
  }

  const potentialDrives = DRIVE_POTENTIAL[key];
  if (!potentialDrives) return false;
  return potentialDrives.some((drive) => drive.rating === rating);
};

export const validateDriveRating = (
  type: DriveType,
  rating: number,
): string[] => {
  const errors: string[] = [];

  let key: keyof typeof DRIVE_POTENTIAL;
  switch (type) {
    case DriveType.MANEUVER:
      key = "MANEUVER";
      break;
    case DriveType.JUMP:
      key = "JUMP";
      break;
    case DriveType.REACTION:
      key = "REACTION";
      break;
    default:
      errors.push(`Invalid drive type: ${type}`);
      return errors;
  }

  const potentialDrives = DRIVE_POTENTIAL[key];
  if (!potentialDrives) {
    errors.push(`Invalid drive type: ${type}`);
    return errors;
  }

  const validRatings = potentialDrives.map((drive) => drive.rating);
  if (!validRatings.includes(rating)) {
    errors.push(
      `Invalid ${type} drive rating: ${rating}. Valid ratings are: ${validRatings.join(", ")}`,
    );
  }

  return errors;
};

export interface DriveSpec {
  name: string;
  powerRequirement: number;
  costPerTon: number;
  fuelPerJump: number;
  techLevel: number;
  minRating: number;
  maxRating: number;
}
